import React from 'react';
import { DiscoveryBlock } from '@teko/discovery';
import { useSearch } from 'hooks';
import { ProductCarouselWithHeader } from '@teko/teko-ecommerce';
import {
  convertObjectDiscoveryToQueryStringSearch,
  cookDiscoveryFilter,
} from 'helpers';
import { LIMIT_ITEM_PER_PAGE_PRODUCT_LIST } from 'constants/index';
import { isServerless } from 'helpers';
import { getTrackingData } from '@teko/tracking';
import { ProductCardProps } from '@teko/types/ecommerce';

interface BestSellingProductsBlockProps {
  block: DiscoveryBlock;
  productPerView?: number;
  ssrProducts?: ProductCardProps[];
}

export const BestSellingProductsBlock: React.FC<
  BestSellingProductsBlockProps
> = ({
  block,
  productPerView,
  ssrProducts = [],
}: BestSellingProductsBlockProps) => {
  const { result: bestSellingData, isLoading } = useSearch(
    block && {
      ...block.cookedData.paramsObject,
      blockId: block.id,
      pageSize: LIMIT_ITEM_PER_PAGE_PRODUCT_LIST,
    },
    {
      products: ssrProducts,
    },
  );

  if (!isLoading && !bestSellingData?.products?.length) return null;

  const link =
    block?.viewMoreUrl ||
    `${convertObjectDiscoveryToQueryStringSearch({
      ...cookDiscoveryFilter(block.cookedData.paramsObject?.filter),
      ...block.cookedData?.paramsObject?.sorting,
    })}`;

  return (
    <ProductCarouselWithHeader
      header={{
        title: block.label,
        titleColor: 'white',
        link: {
          color: 'white',
          href: link,
        },
      }}
      productsPerRow={productPerView || 5}
      products={bestSellingData?.products || []}
      background={block.backgroundImageUrl}
      virtual={isServerless()}
      tracking={getTrackingData({
        regionName: `${block.label}HorizontalBlock`,
        isTrackContent: true,
      })}
    />
  );
};
